module.exports = __webpack_public_path__ + "static/img/solution_banner2.28c567f3.png";